export default {
  es: {
    dialogActionsHistory:"Historial",
    dialogActionsTest:"Prueba",
    dialogActionsEvaluations:"Evaluaciones",
    dialogActionsActivity:"Actividad",
    dialogActionsProgress:"Progreso",
    dialogActionsAttendance:"Asistencia",
    dialogActionsEditStudent:"Editar estudiante",
    tutorialStudent:"Tutorial para Estudiante",
    tutorialTutor:"Tutorial para Tutor",
    workSheets:"Hojas de trabajo",
    whatSearch:"Ingresa frase para buscar",
    search:"Buscar...",
    whatGrade:"En que grado te encuentras",
    canTakeExam: 'Usted no pude tomar este examen',
    bannerTitle: 'El éxito',
    bannerText: 'no es un accidente',
    courseProgress: 'Progreso del grado',
    home: 'Inicio',
    search: 'Buscar',
    practices: 'Prueba estatal',
    glossary: 'Glosario',
    books: 'Librería',
    signOut: 'Salir',
    back: 'Regresar',
    cancel: 'Cancelar',
    language: 'Idioma',
    worksheet: 'Tareas',
    spellingHelperDictionary: 'Diccionario',
    attendanceCalendar: {
      attend: 'Llego',
      absent: 'Ausente',
      showActivityReport: 'Informe de actividad',
    },
    dictionary: {
      title: 'Diccionario',
      my: 'Mi',
      fullTitle: 'Mi TPM Diccionario',
      searchWord: 'Buscar palabra',
      search: 'Buscar',
      noWordSelected: 'No se ha seleccionado una palabra',
      list: 'Lista',
      resultsNotFound: 'Resultados no encontrados.',
      definition: 'Definición',
      englishResults: 'Se muestran resultados de búsqueda en inglés',
    },
    student: {
      history: 'Historial',
      progress: 'Progreso',
    },
    filter: {
      filters: 'Filtros',
      selectedRange: 'Rango seleccionado',
    },
    activity: {
      question: '¿Sigues ahí?',
      text: 'Haga clic en SÍ para continuar, de lo contrario la sesión se cerrará automáticamente',
      activity: 'Sesión de estudio',
      timeStart: 'Inicio',
      timeEnd: 'Finalización',
      timeActiveTotal: 'Tiempo de estudio',
      grade: 'Grado',
      timeActiveInGrade: 'Tiempo activo en el grado',
      gradeNotActivity: 'No actividad en grado',
      subject: 'Materia',
      timeActivieInSubject: 'Tiempo total activo en esta materia.',
      subjectNotActivity: 'No actividad en la materia.',
      cluster: 'Tema',
      timeActivieInCluster: 'Tiempo activo total en el tema',
      clusterNotActivity: 'No actividad en el tema',
      testPresented: 'Test presentado',
      testAverage: 'Promedio del examen',
      listLessons: 'Lista de lecciones',
      lessonName: 'Lección',
      lessonQuizPresented: 'Quiz',
      lessonAverageScore: 'Promedio',
      lessonTimeActive: 'Tiempo de actividad',
    },
    showActivityTime: {
      noHistory: 'No hay historial',
      date: 'Fecha',
      start: 'Inicio',
      end: 'Finalizó',
      activityTime: 'Tiempo activo',
      inactiveTime: 'Tiempo inactivo',
      details: 'Detalles',
    },
    messages: {
      processing: 'Procesando petición',
      accessDenied: 'Acceso denegado',
      areYouSure: 'Estas seguro?',
      allStudent: 'Toda la información del estudiante será eliminada, no puede ser recuperada.',
      deleted: 'Eliminado!',
      yourFile: 'Usuario eliminado satisfactoriamente.',
      succes: 'Éxito',
      youWontBe: 'No podrás revertir esto!',
      changePassword: 'Cambiar mi contraseña',
      doNotChangePass: 'No cambiar mi contraseña',
      ops: 'Oops Algo salio mal.',
      toApply:
        'Para aplicar una evaluación a un estudiante, primero debe registrar a un estudiante del Grado 1 en adelante',
      newStudent: 'Nuevo estudiante',
      ups: 'Upss!',
      incertCd: 'Inserte el CD TPM e-library para continuar',
      printPage: 'Imprimir',
      endSession: 'Si hace clic en "Si", esta sesión se cerrará automáticamente. ¿Desea continuar?',
      yes: 'Si',
      no: 'No',
      text: 'No existen hojas de trabajo para esta lección',
    },
    languages: {
      es: 'Spanish',
      en: 'English',
      selectLang: 'Idioma seleccionado',
      chooseLang: 'Idioma',
      mxAndUsa: 'México y Estados Unidos',
    },
    intro: {
      show: 'Mostrar video de inicio:',
      yes: 'Si',
      no: 'No',
    },
    lessonAudio: {
      play: 'Reproducir audio inicial en lecciones:',
    },
    navbar: {
      back: 'Regresar',
      changeLanguage: 'Cambiar idioma',
    },
    avatar: {
      title: 'Selecciona tu Avatar',
      upload: 'Subir archivo',
      save: 'Guardar',
    },
    singup: {
      createNewTutor: 'Registra un nuevo tutor',
      createAccountChild: 'Registra un nuevo estudiante',
      name: 'Nombre',
      nameIsRequired: 'Nombre es requerido, caracter incorrecto o se excede',
      lastNameRequired: 'Apellido es requerido, excedido o carácteres incorrectos',
      grade: 'Grado',
      accessAllContent: 'Acceso a todo el contenido',
      restrictedContent: 'Acceso restringido',
      schoolNameRequired: 'Nombre de escuela requerido',
      email: 'Correo electronico',
      emailRequired: 'El correo es requerido o formato invalido',
      username: 'Nombre de usuario',
      usernameInUse: 'Nombre de usuario en uso',
      usernameRequired: 'Nombre de usuario requerido',
      password: 'Contraseña',
      verifyNewPassword: 'Verifica tu nueva contraseña, maximo 7 caracteres',
      passwordRequired: 'Contraseña es requerida o minimo 6 caracteres',
      verifyYourPassword: 'Verifica tu contraseña',
      verifyYourPasswordMaxSeven: 'Verifica tu contraseña, maximo 7 caracteres',
      verifyPasswordIsRequired: 'Verifica tu contraseña es requerida',
      clickSetPassword: 'Click! Poner contraseña',
      clickNotSetPassword: 'Click! Sin contraseña',
      cancel: 'Cancelar',
      submit: 'Guardar',
      emailEx: 'nombre@ejemplo.com',
      usernameEx: 'Ej. alex',
      successfulRegistration: 'Registro exitoso',
      student: 'Estudiante',
      whatDoYouWant: '¿Qué quieres hacer?',
      studentList: 'Ver lista de estudiantes',
      forgotPw: '¿Olvidaste tu contraseña?',
      pwRecovery: 'Recuper Contraseña',
      pleaseEnter: 'Por favor ingrese su nombre de Usuario y Correo:',
      recoveryErr: 'Verifique que su nombre de Usuario y Correo sean correctos.',
      save: 'Guardar',
    },
    testBooks: {
      settings: 'Configuración',
      logout: 'Salir',
    },
    lessonSearch: {
      category: 'Todas las categorías',
      search: 'Buscar',
      lesson: 'Lección',
      noResultFound: 'No se encontraron resultados',
      previous: 'Anterior',
      next: 'Siguiente',
      cluster: 'Grupo',
    },
    clusterC: {
      of: 'de',
      completed: 'Progreso de lecciones',
      takeTest: 'Prueba',
      chooseSubject: 'Selecciona una materia para continuar',
      practice: 'Prácticas',
    },
    mainCategories: {
      welcome: 'Bienvenido',
      selectGrade: 'Selecciona el grado para registrar a un estudiante.',
      registerEstudent: 'Nuevo estudiante.',
      creatAnAccountChild: 'Registrar a un nuevo alumno.',
    },
    instructions: {
      youDidIt: 'Lo lograste!',
      congratulations: 'Felicitaciones!',
      youAreDone:
        'Has terminado con esta lección, haz clic en "continuar" para realizar una prueba previa que desbloqueará la siguiente lección.',
      youAreDoneCluster:
        'Ha terminado con este clúster, haga clic en "continuar" para realizar una prueba que desbloqueará el siguiente clúster.',
      continue: 'Continuar',
    },
    global: {
      title: 'Titulo',
      singin: 'Entrar',
      singout: 'Cerrar',
      done: 'Aceptar',
      next: 'Siguiente',
      hello: 'Hola',
      games: 'Juegos',
      gameDone: 'Continuar',
      glossary: 'Glosario',
      library: 'Biblioteca',
      backMenuGame: 'Regresa a menú de juegos',
      titleGames: 'Seleccione un juego!',
      gameTips:
        'Puede que algunos juegos no se adapten a la resolución de smartphone. Para una mejor experiencia, utiliza tu computadora o tablet',
    },
    test: {
      whenYoorReady: 'Cuando estes listo, presiona el botón que dice "iniciar" para comenzar la prueba',
      start: 'Iniciar',
      selectCorrectAnswer: 'Selecciona la respuesta correcta',
      question: 'Pregunta:',
      check: 'Comprobar',
    },
    charst: {
      studentTime: 'Tiempo de estudio:',
      in: 'en',
      with: 'con',
      timesRepeated: 'Tiempo repetido.',
      time: 'tiempo',
      holdTigth: 'Espera un momento, estamos recopilando tu información ...',
      progress: 'Progreso',
    },
    manageContentByGrade: {
      manaContentGrade: 'Administrar contenido por grado',
      chooseStudent:
        'Elija un alumno y le mostrará una lista de temas y clústeres que le pertenecen, puede habilitar o deshabilitar los clústeres que desee.',
      nowThatYouCorrectly:
        'Ahora que seleccionó correctamente a un alumno, puede elegir de la lista de temas y grupos que se enumeran a continuación. Además, puede habilitar o deshabilitar los clusters que desee.',
      pleaseSelectOne: 'Porfavor seleccione uno',
      grade: 'Grado',
      chooseAnotherStudent: 'Elije otro estudiante',
      studentHasNotBeen: 'El estudiante no ha sido seleccionado aún.',
      pretest: 'Prueba',
      test: 'Examen',
      configTest: 'Configuración de las pruebas',
      enableOrDisableTest: 'Habilitar o deshabilitar las pruebas',
      enable: 'Habilitado',
      disable: 'Inhabilitado',
      setTime: 'Establecer tiempo',
      notTime: 'Sin tiempo',
      seconds15: '00:15 segundos',
      seconds30: '00:30 segundos',
      seconds45: '00:45 segundos',
      minute1: '1:00 minuto',
      minute130: '1:30 minuto',
      minute2: '2:00 minuto',
      minute230: '2:30 minuto',
      minute3: '3:00 minuto',
      chooseAStudent: 'Elige un estudiante',
      selectAll: 'Seleccionar Todo',
    },
    resultBoardTest: {
      title: 'Calificación de Prueba',
      review: 'Revisar Prueba',
      reviewTab: 'Revisión',
      scoreTab: 'Calificación',
      modalTitle: 'Revisión de Prueba',
      qualification: 'Calificación:',
      correctAnswers: 'Respuestas correctas:',
      incorrectAnswers: 'Respuestas incorrectas:',
      skippedAnswers: 'Respuestas saltadas:',
      totalQuestions: 'Preguntas totales:',
      start: 'Fecha:',
      timeUsed: 'Tiempo utilizado:',
      spentTime: 'Tiempo agotado',
      name: 'Nombre:',
      subject: 'Materia:',
      cluster: 'Tema:',
      attempt: 'Intento No.',
      skipped: 'Omitido',
    },
    pretest: {
      chooseCorrectAnswer: 'Elige la respuesta correcta',
      false: 'FALSO',
      true: 'VERDADERO',
      submit: 'Guardar',
      cancel: 'Cancelar',
      exit: 'Salir',
      next: 'Siguiente',
      correctAnswer: 'Respuesta correcta',
      tryAgain: 'Oops! Inténtalo de nuevo',
    },
    testTest: {
      doubleClickCorrect: 'Selecciona la respuesta correcta',
      validate: 'Validar',
      skip: 'Saltar',
      continue: 'Continuar',
      submit: 'Guardar',
      cancel: 'Cancelar',
      timeOverMessage: 'Tiempo agotado en pregunta actual',
    },
    editProfileStudent: {
      profileInfo: 'Información de cuenta',
      editInformation: 'Información del estudiante',
      editYourInformation: 'Edita tu información',
      newPassword: 'Nueva contraseña',
      updatePassword: 'Actualizar contraseña',
      noUpdatePassword: 'No actualizar contraseña',
      infoSecurityPassword: 'No tienes una contraseña asignada',
    },
    profile: {
      personalInformation: 'Información personal',
      gradeLevel: 'Nivel de grado:',
      registreAt: 'Registrado en:',
      changeAvatar: 'Cambia tu imagen',
      closeBoard: 'Cerrar Menu',
    },
    evaluation: {
      evaluation: 'Evaluación',
      selectTheName: '1. Seleccione el nombre del estudiante que desea evaluar.',
      studentName: 'Nombre del estudiante',
      chooseGradeStudent: '2. Elija el grado del estudiante.',
      selectThespecific:
        '3. Seleccione la materia específica con la que desea evaluar al alumno o haga clic en "Todas las materias" para realizar una evaluación completa.',
      subject: 'Materia',
      typeEvaluation: 'Tipo de evaluación',
      fullEvaluation: 'Completa',
      lightEvaluation: 'Ligera',
      startTest: 'Empezar Test',
    },
    fullResult: {
      result: 'Resultados:',
      recommendations: 'Recomendaciones:',
      itIsSuggested: 'Se sugiere centrar más estudios en:',
      previousStatistics: 'Estadísticas previas',
      previousResults: 'Resultados anteriores',
    },
    previousResults: {
      scoreComparison: 'Puntuación de comparación',
      todayEvaluation: 'Evaluación de hoy',
      noHistory: 'Sin historial de evaluaciones',
      previousEvaluation: 'Evaluación previa',
    },
    children: {
      notUserRegistered: 'No hay usuarios.',
      registerNewUser: 'Registra un nuevo usuario.',
      minutsOf: 'Minutos de',
      totalActivity: 'actividad total',
      lastActivity: 'Última actividad en la aplicación',
      hadNoActivity: 'No hay registro de actividad en la última semana. ¡Volvamos a aprender!',
      letsGoBack: '¡Regresemos a aprender!',
      viewSummary: 'Progreso',
      edit: 'Editar',
      tests: 'Examenes',
      showAllTestsTitle: 'Tests realizados',
      noTestsPerformed: 'Este estudiante no tiene pruebas realizadas',
      noTestSelected: 'Elija el test que desea ver',
      activityTime: 'Tiempo de actividad',
      showActivityTimeTitle: 'Informe diario de actividad',
      attendanceCalendar: 'Calendario de asistencia',
      editStudentProfile: 'Editar perfil del alumno',
    },
    editProfileTutor: {
      newUsername: 'Nuevo nombre de usuario',
      intoYourPassword: 'Introduce tu contraseña',
      yourPassword: 'Tu Contraseña',
      first: 'Primer nombre',
      last: 'Apellido',
    },
    help: {
      title: 'ayuda',
      warranty: 'Garantía',
      contact: 'Contáctanos',
      guide: 'Guía para padres',
      support: 'Soporte técnico',
      demoTutor: 'Tutorial para tutor',
      demoStudent: 'Tutorial para estudiante',
      contactInfo: {
        hmp: 'Home & Media Products, LLC.',
        address: '8635 Florence Ave Suite 205, Downey, CA 90240',
        phone: 'Teléfono: 562-366-1763',
        fax: 'Fax: 562-252-0692',
        web: 'Sitio web: www.myhmp.org',
        cs: 'Servicio a cliente: help@myhmp.org',
      },
      techSupportInfo: {
        email: 'E-mail: help@mytpm.org',
        available: 'Disponible de:',
        open: '9:00am a 6:00pm - Lunes a Viernes',
      },
      chooseVideo: 'Elige un video y da click en ',
      expandIcon: ' para expandirlo',
      // homeAndMedia: '2018, HOME & MEDIA Products, LLC. Todos los derechos reservados Términos de uso y política de privacidad.'
    },
    settings: {
      study: 'Estudio 101',
      theBestWayChildrenFocus:
        'La mejor manera de mantener a los estudiantes enfocados en un tema específico es controlando a qué temas pueden acceder y cuáles no. De esta manera, puede crear el plan de estudio más eficiente y efectivo para su hijo.',
      sendingReports: 'Envío de informes al correo electrónico',
      theBestWayAlwaysInformed:
        'Para mantenerse informado sobre el progreso de sus estudiantes, se le pueden enviar informes por correo electrónico. También puede habilitar / deshabilitar la animación de inicio de sesión que se muestra cuando se inicia el programa.',
      statusOfSending: 'Informes por email',
      setEmailDefault: 'Establecer correo electrónico de forma predeterminada',
      nameOfTutor: 'Nombre del tutor',
      applayEvaluation: 'Aplicar evaluación por estudiante',
      testMeasure:
        'Las pruebas miden la comprensión de los alumnos de las lecciones. Puede realizar un seguimiento del progreso de los estudiantes con un sistema de evaluación fácil pero efectivo.',
      changeLanguage: 'Cambiar el idioma de la aplicación',
      worksheets: 'Tareas',
      worksheetDescription:
        'Aquí encontrarás hojas de tarea para cada lección; estas hojas ayudarán a tus estudiantes a practicar y repasar lo que han aprendido.',
      selectUserFirst: 'Seleccionar un usuario primero',
      copyContent: 'Copiar contenido a Disco Duro',
      copyContentDescription: 'Aquí puedes copiar tu contenido de TPM de los CDs a tu Disco de almacenamiento local.',
    },
    copyContent: {
      select: 'Por favor seleccione el contenido a copiar:',
      noGradeSelected: 'Favor de seleccionar al menos un grado.',
      warning:
        'Este proceso toma varios minutos para completarse. Favor de no apagar su PC, cerrar la aplicación o remover los CDS mientras se copian los archivos.',
      pleaseInsert: 'Favor de insertar el DVD con el contenido de la materia:',
      pressContinue: 'Una vez insertado el DVD, presione el botón para continuar.',
      continue: 'Continuar',
      cancel: 'Cancelar',
      success: 'El contenido ha sido copiado a su Disco Duro exitosamente!',
      return: 'Regresar',
      media: 'Recursos (Libros y Hojas de tarea)',
    },
    sidebar: {
      viewProfile: 'Ver perfil',
      yourChildren: 'Estudiantes',
      tutors: 'Tutores',
      help: 'Ayuda',
      savedSatis: 'Guardado satisfactoriamente',
      addStudent: 'Add Student',
      addTutor: 'Add Tutor',
    },
    tutors: {
      listTutors: 'Lista de tutores',
      thereIsStils: 'Todavía no hay registro de nuevos tutores.',
      firstName: 'Primer nombre',
      lastName: 'Primer Apellido',
      details: 'Detalles',
      remove: 'Eliminar',
      evaluations: 'Evaluaciones',
      tutorGeneral: 'Información general del tutor',
      tutor: 'Tutor',
      registered: 'Registrado',
      username: 'Nombre de usuario',
      password: 'Contraseña',
    },
    login: {
      pleaseCheck:
        'Por favor verifique su nombre de usuario y contraseña. Los campos son sensibles a mayúsculas y minúsculas',
      send: 'Enviar',
    },
    lessons: {
      doTheQuiz: 'Haz la prueba previa',
      finishedLesson: 'Haga clic en "Continuar" para tomar una prueba para desbloquear la siguiente lección',
      go: 'Ir',
      continueLearning: 'Continúa aprendiendo',
    },
    basicBtnNavegation: {
      testApproved: 'Felicidades test aprobado',
      winAccessGame: 'Te ganaste acceso a un juego',
      play: 'Play!',
    },
    testboard: {
      // Trabajar en esta parte, no son necesarios todo este contenido
      goodJob: 'Buen Trabajo!',
      nowYouCan: 'Ahora puedes ir a la siguiente lección y aprender mucho más. ¡Buena suerte!',
      nextLesson: 'Siguiente lección',
      nextCluster: 'Reintentar',
      clusterFinished: 'Tome un examen para continuar',
      maybeYouNeedStudy: 'Quizás necesites estudiar un poco más.',
      dontGiveUp: '¡No te rindas e intenta de nuevo!',
      oneMoreTime: 'Una vez más',
      youHaveThree: 'Tienes tres o más respuestas correctas. Ahora puedes pasar a la siguiente lección, sigue así.',
      youDidGreat: 'Lo hiciste genial',
      tryAgain: 'Inténtalo de nuevo',
      getBeterScore: 'Obtenga una mejor puntuación para poder pasar a la siguiente lección.',
    },
    resultsQuiz: {
      approved: {
        title: 'Buen trabajo!',
        msg: 'Ahora puedes ir a la siguiente lección y aprender mucho más. ¡Buena suerte!',
      },
      notApproved: {
        title: '¡No te rindas e intenta de nuevo!',
        msg: 'Obtenga una mejor puntuación para poder continuar con la siguiente lesson.',
      },
    },
    templates: {
      youFinishedLesson: 'Has terminado tu lección.',
      letsSeeHow: 'Veamos cuánto has aprendido. Ve a la',
      quiz: 'prueba',
      toAprove: 'para demostrar su conocimiento.',
      goToQuiz: 'Ir a la prueba',
    },
    activator: {
      welcome: 'Bienvenido',
      welcomeTo: 'Bienvenido a nuestra aplicación de instalación y gracias por escoger a',
      tpm: 'TPM, "The Perfect classMate"',
      chooseLanguage: 'Idioma:',
      selectActivation: 'Selecciona cómo te gustaría activar tu software TPM:',
      onlineActivation: 'Activacion Online',
      phoneActivation: 'Activación por Teléfono',
      online: {
        description: 'Escribe la siguiente información para activar tu software TPM:',
        serial: 'Número de Serie',
        box: 'Número de Caja',
        firstName: 'Nombre',
        lastName: 'Apellidos',
        email: 'E-mail',
        address: 'Dirección',
        optional: 'opcional',
        city: 'Ciudad',
        state: 'Estado',
        mobile: 'Celular',
        home: 'Teléfono Casa',
        required: 'Información Requerida',
        terms: 'Términos y Condiciones',
        read: 'He leído y acepto los Términos y Condiciones y Política de Privacidad.',
        back: 'Regresar',
        submit: 'Enviar',
      },
      phone: {
        step: 'Paso',
        description1: 'Encuenta el siguiente sticker en la caja de tu producto TPM:',
        description2:
          'Para servirte mejor, por favor ten lista la siguiente información antes de llamar para solicitar la activación de tu producto TPM:',
        description3: 'Sigue las instrucciones de tu Representativo de Servicio al Cliente TPM.',
        info1: 'Número de licencia TPM.',
        info2: 'Número de caja TPM.',
        info3: 'Código de activación.',
        activationNumber: 'Código de Activación',
        keyNumber: 'Número de Serie',
        keyNumberRequired: 'Número de Serie requerido.',
        please1: 'Por favor ingresa el número de licencia y número de caja:',
        please2: 'Por favor lee el número mostrado aquí abajo a tu Representativo de Servicio al Cliente TPM:',
        please3:
          'Por favor sigue las instrucciones de tu Representativo de Servicio al Cliente TPM y escribe los números en la caja siguiente:',
        back: 'Regresar',
        next: 'Siguiente',
        submit: 'Enviar',
        callUs: 'Llámanos:',
        schedule: 'Lunes a Viernes de 9 am a 6 pm Hora Estándar del Pacífico.',
        invalidlicensenumber: 'Verifique que el número de caja y el número de licencia sean correctos.',
        licenseNumberNotValid: 'Número de licencia no válido.',
        keyNumberNotValid: 'Número clave no válido.',
      },
    },
    worksheets: {
      selectGrade: 'Selecciona el grado:',
      selectSubject: 'Selecciona la materia:',
      cluster: 'Grupo',
      lesson: 'Lección',
      lessonid: 'ID',
      worksheet: 'Tareas',
      answer: 'Respuestas',
      download: 'Descargar',
      view: 'Ver',
      na: 'N/D',
      notFound: 'Lección no cumple con practicas',
    },
    updateNotification: {
      title: 'Nueva versión disponible.',
      subtitle: '¿Te gustaría instalar los últimos cambios a la aplicación?',
      subtitle2: 'Descargando...',
      yes: 'Si',
      yesNotice: 'TPM se reiniciará automaticamente cuando la actualización esté lista.',
      no: 'No',
      restartNotice: 'Para volver a ver este mensaje favor de reiniciar la aplicación.',
    },
    welcome: {
      welcome: 'Bienvenido',
      tutor: 'Tutor',
      student: 'Estudiante',
    },
    tpmWebRegistration: {
      title: 'Tenemos un regalo para ti...',
      text1:
        'Ahora con <strong>TPM Web</strong> puedes acceder a todo el contenido de TPM desde cualquier navegador o dispositivo móbil.',
      subtitle: 'Prueba TPM Web por 180 días*, ¡absolutamente gratis!',
      text2:
        'Para comenzar tu periodo de prueba ingresa un correo válido para recibir tu <strong>Clave de Cliente</strong> la cual te permitirá utilizar TPM Web en <strong>hasta 4 cuentas</strong>.',
      emailLabel: 'Correo',
      emailLabel2: 'Verificar Correo',
      emailWarning: 'Por favor ingresa un correo válido.',
      emailWarning2: 'Los correos no son iguales.',
      register: 'Comenzar prueba gratuita',
      cancel: 'Saltar**',
      note1:
        '* Si te gustaría seguir utilizando <strong>TPM Web</strong> después de tu periodo de prueba, contactar a Home & Media Products al <strong>(562) 366 1763</strong> o a <strong>help@myhmp.org</strong>',
      note2:
        '** Para acceder a esta pantalla más tarde, ingresar a Tutor -> Configuración -> Pestaña Configuración -> TPM Web.',
    },
    modalTimeout: {
      title: 'Inactividad detectada!',
      message: 'Se ha detectado un tiempo sin ninguna actividad, que deseas hacer?',
      btnCancel: 'Permanecer en sesion',
      btnConfirm: 'Cerrar sesion',
    },
    userNotification:{
      title:'Bienvenido'
    }
  },

  en: {
    dialogActionsHistory:"History",
    dialogActionsTest:"Test",
    dialogActionsEvaluations:"Evaluations",
    dialogActionsActivity:"Activity",
    dialogActionsProgress:"Progress",
    dialogActionsAttendance:"Attendance",
    dialogActionsEditStudent:"Edit student",
    tutorialStudent:"Tutorial for Student",
    tutorialTutor:"Tutorial for Tutor",
    workSheets:"Worksheets",
    whatSearch:"Enter phrase to search",
    search:"Search...",
    whatGrade:"What grade are you in",
    canTakeExam: 'You could not take this exam',
    bannerTitle: 'The success',
    bannerText: 'It\'s not an accident',
    courseProgress: 'Grade Progress',
    home: 'Home',
    search: 'Search',
    practices: 'State test',
    glossary: 'Glossary',
    books: 'e-library',
    signOut: 'Sign Out',
    back: 'Back',
    cancel: 'Cancel',
    language: 'Language',
    worksheet: 'Worksheets',
    spellingHelperDictionary: 'Dictionary',
    attendanceCalendar: {
      attend: 'Attend',
      absent: 'Absent',
      showActivityReport: 'Show activity report',
    },
    dictionary: {
      title: 'Dictionary',
      my: 'MY',
      fullTitle: 'My TPM Dictionary',
      searchWord: 'Search word',
      search: 'Search',
      noWordSelected: 'No Word Selected',
      list: 'List',
      resultsNotFound: 'Results not found.',
      definition: 'Definition',
      englishResults: '',
    },
    student: {
      history: 'Record',
      progress: 'Progress',
    },
    filter: {
      filters: 'Filters',
      selectedRange: 'Selected range',
    },
    activity: {
      question: 'Are you still there?',
      text: 'Click YES to continue otherwise session will close automatically',
      activity: 'Studying Session',
      timeStart: 'Start',
      timeEnd: 'End',
      timeActiveTotal: 'Study Time',
      grade: 'Grade',
      timeActiveInGrade: 'Active time in the grade',
      gradeNotActivity: 'No activity in the grade',
      subject: 'Subject',
      timeActivieInSubject: 'Total active time on this subject',
      subjectNotActivity: 'No activity in the subject.',
      cluster: 'Cluster',
      timeActivieInCluster: 'Tiempo activo total en el tema',
      clusterNotActivity: 'No activity in the cluster',
      testPresented: 'Test presented',
      testAverage: 'Average score',
      listLessons: 'List of lessons',
      lessonName: 'Lesson',
      lessonQuizPresented: 'Quiz',
      lessonAverageScore: 'Score',
      lessonTimeActive: 'Activity Time',
    },
    showActivityTime: {
      noHistory: 'No history',
      date: 'Date',
      start: 'Start',
      end: 'Finished',
      activityTime: 'Active time',
      inactiveTime: 'Inactive time',
      details: 'Details',
    },
    messages: {
      processing: 'Processing request',
      accessDenied: 'Access denied',
      areYouSure: 'Are you sure?',
      allStudent: 'All student information will be deleted, it cannot be recovered.',
      deleted: 'Deleted!',
      yourFile: 'User successfully removed.',
      succes: 'success',
      youWontBe: "You won't be able to revert this!",
      changePassword: 'Change password',
      doNotChangePass: 'Do not change password',
      ops: 'Oops.. Something Went Wrong.',
      toApply: 'To apply an evaluation to a student, you must first enroll a student from 1st Grade upwards.',
      newStudent: 'New stundent',
      ups: 'Upss!',
      incertCd: 'Insert CD TPM e-library to continue',
      printPage: 'Print',
      endSession: 'If you click "Yes" this session will automatically close. Do you wish to continue?',
      yes: 'Yes',
      no: 'No',
      text: 'There are no worksheets for this lesson',
    },
    languages: {
      es: 'Spanish',
      en: 'English',
      selectLang: 'Selected language',
      chooseLang: 'Language',
      mxAndUsa: 'Mexico and United States',
    },
    intro: {
      show: 'Show intro video:',
      yes: 'Yes',
      no: 'No',
    },
    lessonAudio: {
      play: 'Play initial lesson audio:',
    },
    navbar: {
      back: 'Back',
      changeLanguage: 'Change language',
    },
    avatar: {
      title: 'Select your Avatar',
      upload: 'Upload file',
      save: 'Save',
    },
    singup: {
      createNewTutor: 'Create a new account for the new tutor',
      createAccountChild: 'Create an account for your student',
      name: 'Name',
      nameIsRequired: 'Name is required, incorrect character or exceeded',
      lastNameRequired: 'Last Name Is required, incorrect character or exceeded',
      grade: 'Grade',
      accessAllContent: 'All access',
      restrictedContent: 'Restricted access',
      schoolNameRequired: 'School name is required',
      email: 'Email',
      emailRequired: 'Email is required or format invalid',
      username: 'Username',
      usernameInUse: 'The user is already in use',
      usernameRequired: 'Username is required',
      password: 'Password',
      verifyNewPassword: 'Verify your new password, maximum 7 characters',
      passwordRequired: 'Password is required or at least 6 characters',
      verifyYourPassword: 'Reenter password',
      verifyYourPasswordMaxSeven: 'Verify your password, maximum 7 characters',
      verifyPasswordIsRequired: 'Verify your password is required',
      clickSetPassword: 'Click! Create a password',
      clickNotSetPassword: 'Click! Not set password',
      cancel: 'Cancel',
      submit: 'Submit',
      emailEx: 'username@example.com',
      usernameEx: 'Ex. alex',
      successfulRegistration: 'Successful registration',
      student: 'Student',
      whatDoYouWant: 'What do you want to do?',
      studentList: 'students list',
      forgotPw: 'Forgot your password?',
      pwRecovery: 'Password Recovery',
      pleaseEnter: 'Please enter your Username and Email to continue:',
      recoveryErr: 'Please verify that your Username and Email are correct.',
      save: 'Save',
    },
    testBooks: {
      settings: 'Settings',
      logout: 'Logout',
    },
    lessonSearch: {
      category: 'All categories',
      search: 'Search',
      lesson: 'Lesson',
      noResultFound: 'No result found',
      previous: 'Previous',
      next: 'Next',
      cluster: 'Cluster',
    },
    clusterC: {
      of: 'of',
      completed: 'Lessons progress',
      takeTest: 'Take a Test',
      chooseSubject: 'Select a subject to continue',
      practice: 'Practices',
    },
    mainCategories: {
      welcome: 'Welcome',
      selectGrade: 'Select an grade to register a student.',
      registerEstudent: 'Register a student.',
      creatAnAccountChild: 'Create an account for your student.',
    },
    instructions: {
      youDidIt: 'You made it!',
      congratulations: 'Congrats!',
      youAreDone: 'You have finished the lesson, click "continue" to answer a Quiz to be able to go to next lesson.',
      youAreDoneCluster:
        'You are done with this cluster, click "continue" to take a test which will unlock the next cluster.',
      continue: 'Continue',
    },
    global: {
      title: 'Title',
      singin: 'Sign In',
      singout: 'Sign Out',
      done: 'Done',
      next: 'Next',
      hello: 'Hello',
      games: 'Games',
      gameDone: 'Continue',
      glossary: 'Glossary',
      printPage: 'Imprimir',
      library: 'Library',
      backMenuGame: 'Return a game menu',
      titleGames: 'Select a game!',
      gameTips:
        'Some games may not be adapted to the smartphone resolution. Use your computer or tablet for better experience',
    },
    test: {
      whenYoorReady: 'When you are ready, press the button that says "start" to start the test',
      start: 'Start',
      selectCorrectAnswer: 'Select the correct answer',
      question: 'Question:',
      check: 'Check',
    },
    charst: {
      studentTime: 'Studied Time:',
      in: 'in',
      with: 'with',
      timesRepeated: 'times repeated.',
      time: 'time',
      holdTigth: "Hold tight, we're gathering your information...",
      progress: 'Progress',
    },
    manageContentByGrade: {
      manaContentGrade: 'Manage content by grade',
      chooseStudent:
        'Choose a student and it will show you a list of subjects and clusters that belong to it, you can enable or disable the clusters you want.',
      nowThatYouCorrectly:
        'Now that you correctly selected a student you can choose from the list of subjects and clusters that are listed below. Also, you can enable or disable the clusters you want.',
      pleaseSelectOne: 'Please select one',
      grade: 'Grade',
      chooseAnotherStudent: 'Choose another student',
      studentHasNotBeen: 'Student has not been selected yet.',
      pretest: 'Quiz',
      test: 'Test',
      configTest: 'Configuration of the tests',
      enableOrDisableTest: 'Enable or disable the tests',
      enable: 'Enable',
      disable: 'Disable',
      setTime: 'Set a time',
      notTime: 'Not time',
      seconds15: '00:15 seconds',
      seconds30: '00:30 seconds',
      seconds45: '00:45 seconds',
      minute1: '1:00 minute',
      minute130: '1:30 minute',
      minute2: '2:00 minute',
      minute230: '2:30 minute',
      minute3: '3:00 minute',
      chooseAStudent: 'Choose a student',
      selectAll: 'Select All',
    },
    resultBoardTest: {
      title: 'Test Score',
      review: 'Test Review',
      reviewTab: 'Review',
      scoreTab: 'Score',
      modalTitle: 'Test Review',
      qualification: 'Score:',
      correctAnswers: 'Correct answers:',
      incorrectAnswers: 'Incorrect answers:',
      skippedAnswers: 'Skipped answers:',
      totalQuestions: 'Total questions:',
      start: 'Date:',
      timeUsed: 'Time spent:',
      spentTime: 'Time out',
      name: 'Name:',
      subject: 'Subject:',
      cluster: 'Cluster:',
      attempt: 'Attempt No.',
      skipped: 'Skipped',
    },
    pretest: {
      chooseCorrectAnswer: 'Choose the correct answer',
      false: 'FALSE',
      true: 'TRUE',
      submit: 'Submit',
      cancel: 'Cancel',
      exit: 'Exit',
      next: 'Next',
      correctAnswer: 'Correct!',
      tryAgain: 'Oops! Try again',
    },
    testTest: {
      doubleClickCorrect: 'Select the correct answer',
      validate: 'Validate',
      skip: 'Skip',
      continue: 'Continue',
      submit: 'Submit',
      cancel: 'Cancel',
      timeOverMessage: 'Spent time for this question',
    },
    editProfileStudent: {
      profileInfo: 'Profile information',
      editInformation: 'Student information',
      editYourInformation: 'Edit your information',
      newPassword: 'New password',
      updatePassword: 'Update password',
      noUpdatePassword: 'Not update password',
      infoSecurityPassword: "You don't have an assigned password",
    },
    profile: {
      personalInformation: 'About You',
      gradeLevel: 'Grade:',
      registreAt: 'Joined in:',
      changeAvatar: 'Change your avatar.',
      closeBoard: 'Close the board menu.',
    },
    evaluation: {
      evaluation: 'Evaluation',
      selectTheName: '1. Select the name of the student you want to evaluate.',
      studentName: 'Student name',
      chooseGradeStudent: '2. Choose the grade of the student.',
      selectThespecific:
        '3. Select the specific subject you want to evaluate the student with or click "All Subjects" to have a full evaluation.',
      subject: 'Subject',
      typeEvaluation: 'Type of evaluation',
      fullEvaluation: 'Full',
      lightEvaluation: 'Light',
      startTest: 'Start Test',
    },
    fullResult: {
      result: 'Results:',
      recommendations: 'Recommendations:',
      itIsSuggested: 'It is suggested to focus more studying on:',
      previousStatistics: 'Previous statistics',
      previousResults: 'Previous Results',
    },
    previousResults: {
      scoreComparison: 'Score comparison',
      todayEvaluation: 'Today evaluation',
      noHistory: 'No previous history',
      previousEvaluation: 'Previous evaluation',
    },
    children: {
      notUserRegistered: 'Not users.',
      registerNewUser: 'Register a new user.',
      minutsOf: 'Minutes of',
      totalActivity: 'total activity',
      lastActivity: 'Last activity in the application',
      hadNoActivity: "No activity in the past week. Let's get back to learning!",
      letsGoBack: "Let's go back to learning!",
      viewSummary: 'Progress',
      edit: 'Edit',
      tests: 'Tests',
      showAllTestsTitle: 'Details of tests performed',
      noTestsPerformed: 'This student has no tests performed',
      noTestSelected: 'Choose the test you want to display.',
      activityTime: 'Activity time',
      showActivityTimeTitle: 'Daily activity report',
      attendanceCalendar: 'Attendance calendar',
      editStudentProfile: 'Edit Student Profile',
    },
    editProfileTutor: {
      newUsername: 'New username',
      intoYourPassword: 'Into your password',
      yourPassword: 'Your Password',
      first: 'First Name',
      last: 'Last Name',
    },
    help: {
      title: 'Help',
      warranty: 'Warranty',
      contact: 'Contact us',
      guide: 'Parents guide',
      support: 'Technical support',
      demoTutor: 'Tutorial for tutor',
      demoStudent: 'Tutorial for student',
      contactInfo: {
        hmp: 'Home & Media Products, LLC.',
        address: '8635 Florence Ave Suite 205, Downey, CA 90240',
        phone: 'Phone: 562-366-1763',
        fax: 'Fax: 562-252-0692',
        web: 'Web site: www.myhmp.org',
        cs: 'Customer service: help@myhmp.org',
      },
      techSupportInfo: {
        email: 'E-mail: help@mytpm.org',
        available: 'Available from:',
        open: '9:00am to 6:00pm - Monday to Friday',
      },
      chooseVideo: 'Choose a video and click ',
      expandIcon: ' to expand it',
      // homeAndMedia: '2018, HOME & MEDIA Products, LLC. All Rights Reserved Terms of Use and Privacy Policy.'
    },
    settings: {
      study: 'Study 101',
      theBestWayChildrenFocus:
        'The best way to keep the students focused on specific subject is by controlling which subjects they can access and which they cannot.  This way you can create the most efficient and effective study plan for your child.',
      sendingReports: 'Sending reports to email',
      theBestWayAlwaysInformed:
        "To keep informed of your student's progress, reports can be emailed to you.  You can also enable/disable the login animation that shows when the program starts.",
      statusOfSending: 'Email reports',
      setEmailDefault: 'Set email by default',
      nameOfTutor: 'Name of tutor',
      applayEvaluation: 'Apply evaluation per student',
      testMeasure:
        "Tests measure student's understanding of the lessons. You are able to keep track of student progress with an easy but effective evaluation system.",
      changeLanguage: 'Change the language of the app',
      worksheets: 'Worksheets',
      worksheetDescription:
        "Here you will find worksheets for each lesson; these worksheets will help the students practice and review what they've learned.",
      selectUserFirst: 'Select a user first',
      copyContent: 'Copy content to Drive',
      copyContentDescription: 'Here you can copy your TPM content from CDs into your local storage Drive.',
    },
    copyContent: {
      select: 'Please select the content to copy:',
      noGradeSelected: 'Please select at least one grade.',
      warning:
        'This process can take some time to complete. Please do not turn off your PC, close the application or open the CD Drive while files are being copied.',
      pleaseInsert: 'Please insert the DVD containing the subject:',
      pressContinue: 'Once inside, press the button to continue.',
      continue: 'Continue',
      cancel: 'Cancel',
      success: 'Content has been successfully copied to your Hard Drive!',
      return: 'Return',
      media: 'Media (Books and Worksheets)',
    },
    sidebar: {
      viewProfile: 'Profile',
      yourChildren: 'My Students',
      tutors: 'Tutors',
      help: 'Help',
      savedSatis: 'Saved Successfully',
      addStudent: 'Add Student',
      addTutor: 'Add Tutor',
    },
    tutors: {
      listTutors: 'List of tutors',
      thereIsStils: 'There is still no record of new tutors.',
      firstName: 'First Name',
      lastName: 'Last Name',
      details: 'Details',
      remove: 'Remove',
      evaluations: 'Evaluations',
      tutorGeneral: 'Tutor General Information',
      tutor: 'Tutor',
      registered: 'Registered at',
      username: 'Username',
      password: 'Password',
    },
    login: {
      pleaseCheck: 'Please check your username and password. The fields are case sensitive.',
      send: 'Submit',
    },
    lessons: {
      doTheQuiz: 'Do the Quiz',
      finishedLesson: 'Click "Continue" to take a quiz to unlock next lesson',
      go: 'Go',
      continueLearning: 'Continue learning',
    },
    basicBtnNavegation: {
      testApproved: 'Congratulations test approved',
      winAccessGame: 'You gained access to a game',
      play: 'Play a game!',
    },
    testboard: {
      goodJob: 'Good Job!',
      nowYouCan: 'Now you can go to the next lesson and learn a lot more. Good luck!',
      nextLesson: 'Next Lesson',
      nextCluster: 'Retry',
      clusterFinished: 'Take a test to continue',
      maybeYouNeedStudy: 'Maybe you need to study a little more.',
      dontGiveUp: "Don't give up and try again!",
      oneMoreTime: 'One more time',
      youHaveThree: 'You have three or more corrects answers. You can now move on to the next lesson, keep it up.',
      youDidGreat: 'You did great',
      tryAgain: 'Try again',
      getBeterScore: 'Get a betetr score so you can move on to the next lesson.',
    },
    resultsQuiz: {
      approved: {
        title: 'Good job!',
        msg: 'Now you can go to the next lesson and learn a lot more. Good luck!',
      },
      notApproved: {
        title: 'Do not give up and try again!',
        msg: 'Get a better score to be able to pass to the next lesson.',
      },
    },
    templates: {
      youFinishedLesson: 'You have finished your lesson.',
      letsSeeHow: "Let's see how much you have learned. Go to the",
      quiz: 'quiz',
      toAprove: 'to prove your knowledge.',
      goToQuiz: 'Go to quiz',
    },
    activator: {
      welcome: 'Welcome',
      welcomeTo: 'Welcome to our installation application and thank you for choosing',
      tpm: 'TPM, "The Perfect classMate"',
      chooseLanguage: 'Language:',
      selectActivation: 'Select how you would like to activate your TPM software:',
      onlineActivation: 'Online Activation',
      phoneActivation: 'Phone Activation',
      online: {
        description: 'Write the following information to activate your TPM software:',
        serial: 'Serial Number',
        box: 'Box Number',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'E-mail',
        address: 'Address',
        optional: 'optional',
        city: 'City',
        state: 'State',
        mobile: 'Mobile Phone',
        home: 'Home Phone',
        required: 'Required Information',
        terms: 'Terms and Conditions',
        read: 'I have read and agree to the Terms and Conditions and Privacy Policy',
        back: 'Back',
        submit: 'Submit',
      },
      phone: {
        step: 'Step',
        description1: 'Find the following sticker on your TPM product box:',
        description2:
          'To help serve you better, please have the following information ready before you call to activate your TPM product:',
        description3: 'Follow the instructions of your TPM, Customer Service Representative.',
        info1: 'TPM license number.',
        info2: 'TPM box number.',
        info3: 'Activation code number.',
        activationNumber: 'Activation Number',
        keyNumber: 'Key Number',
        keyNumberRequired: 'Key Number is required.',
        please1: 'Please enter the license and box numbers:',
        please2: 'Please read the number below to your TPM, Customer Service Representative:',
        please3:
          'Please follow the instructions of your TPM, Customer Service Representative and write the numbers on the box below:',
        back: 'Back',
        next: 'Next',
        submit: 'Submit',
        callUs: 'Call us:',
        schedule: 'Monday to Friday from 9 am to 6 pm PST.',
        invalidlicensenumber: 'Verify that the box number and license number are correct',
        licenseNumberNotValid: 'License number not valid',
        keyNumberNotValid: 'Key number not valid',
      },
    },
    worksheets: {
      selectGrade: 'Select a grade:',
      selectSubject: 'Select a subject:',
      cluster: 'Cluster',
      lesson: 'Lesson',
      lessonid: 'ID',
      worksheet: 'Worksheet',
      answer: 'Answers',
      download: 'Download',
      view: 'View',
      na: 'N/A',
      notFound: 'Lesson does not comply with practices',
    },
    updateNotification: {
      title: 'New version available.',
      subtitle: 'Would you like to install the latest changes?',
      subtitle2: 'Downloading...',
      yes: 'Yes',
      yesNotice: 'TPM will restart automatically once the update is ready.',
      no: 'No',
      restartNotice: 'To see this message again please restart your application.',
    },
    welcome: {
      welcome: 'Welcome',
      tutor: 'Tutor',
      student: 'Student',
    },
    tpmWebRegistration: {
      title: "Here's a gift from us...",
      text1: 'Now with <strong>TPM Web</strong> you can access all TPM content from any web browser or mobile device.',
      subtitle: 'Try TPM Web for 180 days*, absolutely free!',
      text2:
        'To start your free trial please enter a valid email to receive a <strong>Customer Key Number</strong> which will allow you to use TPM Web in <strong>up to 4 accounts</strong>',
      emailLabel: 'Email',
      emailLabel2: 'Verify Email',
      emailWarning: 'Please enter a valid email address.',
      emailWarning2: 'Emails do not match.',
      register: 'Begin free trial',
      cancel: 'Skip**',
      note1:
        '* If you would like to continue using <strong>TPM Web</strong> after your trial period, please contact Home & Media Products at <strong>(562) 366 1763</strong> or <strong>help@myhmp.org</strong>',
      note2: '** To access this screen later, please go to Tutor -> Settings -> Settings Tab -> TPM Web.',
    },
    userNotification:{
      title:'Welcome back'
    }
  },
  modalTimeout: {
    title: 'Inactivity detected!',
    message: 'has been detected a long inactivity time, what do you like to do?',
    btnCancel: 'Keep sesion',
    btnConfirm: 'Close sesion',
  },
};
